import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link, useHistory} from 'react-router-dom'
import {fetchSelector, actionCreators} from 'actions'
import api from 'api'
import Form, {makeInitialValues} from 'settings/eGov/Form'
import {handlerNestFormResponse} from 'libs/errorHandler'
import {getState} from 'utils'
import {notifySuccess} from 'store/actions/notify'
import {asyncError} from 'store/actions/asyncError'
import {useFetchEffect} from 'hooks/useFetchEffect'

const Edit = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const token = useSelector((state) => state.auth.token)

  const applicantInformation = useSelector((state) => fetchSelector(state, 'applicant_information_edit').data) || {}
  const contactInformation = useSelector((state) => fetchSelector(state, 'contact_information_edit').data) || {}
  const certificateFile = useSelector((state) => fetchSelector(state, 'certificate_file_edit').data) || {}
  const submissionDestination = useSelector((state) => fetchSelector(state, 'submission_destination_edit').data) || {}
  const laborConsultant = useSelector((state) => fetchSelector(state, 'labor_consultant').data) || {}

  const save = async (values, token) => {
    try {
      const authedApi = api.createWithAuth(token)
      await authedApi.applicantInformation
        .create(values.applicant_information)
        .catch(handlerNestFormResponse('applicant_information'))
      await authedApi.contactInformation
        .create(values.contact_information)
        .catch(handlerNestFormResponse('contact_information'))
      await authedApi.certificateFile
        .create(values.certificate_file || {})
        .catch(handlerNestFormResponse('certificate_file'))
      await authedApi.submissionDestination
        .create(values.submission_destination)
        .catch(handlerNestFormResponse('submission_destination'))
      const state = await getState(dispatch)
      const client = state.client.current
      await authedApi.clients.laborConsultant
        .createOrUpdate(client.id, values.labor_consultant, true)
        .catch(handlerNestFormResponse('labor_consultant'))
      history.push('/settings/egov')
      dispatch(notifySuccess('更新しました'))
    } catch (err) {
      dispatch(asyncError(err))
    }
  }

  useFetchEffect(() => {
    dispatch(
      actionCreators.fetchData('applicant_information_edit', api.createWithAuth(token).applicantInformation.get())
    )
    dispatch(actionCreators.fetchData('contact_information_edit', api.createWithAuth(token).contactInformation.get()))
    dispatch(actionCreators.fetchData('certificate_file_edit', api.createWithAuth(token).certificateFile.get()))
    dispatch(
      actionCreators.fetchData('submission_destination_edit', api.createWithAuth(token).submissionDestination.get())
    )
    dispatch(actionCreators.fetchData('labor_consultant', api.createWithAuth(token).clients.laborConsultant.get()))

    return () => {
      dispatch(actionCreators.fetchDestroy('applicant_information_edit'))
      dispatch(actionCreators.fetchDestroy('contact_information_edit'))
      dispatch(actionCreators.fetchDestroy('certificate_file_edit'))
      dispatch(actionCreators.fetchDestroy('submission_destination_edit'))
      dispatch(actionCreators.fetchDestroy('labor_consultant'))
    }
  }, [token])

  const handleSubmit = (values) => save(values, token)

  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">電子申請情報編集</h1>
        <p className="m-title-main-note">電子申請の情報を設定できます</p>
      </div>
      <div className="l-wrap-xs l-contents-wrap">
        <div className="l-breadcrumb u-mb20">
          <Link to="/settings" className="l-breadcrumb-link">
            設定
          </Link>
          <Link to="/settings/egov" className="l-breadcrumb-link">
            電子申請情報
          </Link>
          <span className="l-breadcrumb-here">電子申請情報編集</span>
          <Form
            initialValues={makeInitialValues({
              applicantInformation,
              contactInformation,
              certificateFile,
              submissionDestination,
              laborConsultant,
            })}
            onSubmit={handleSubmit}
          />
        </div>
      </div>
    </div>
  )
}

export default Edit
